import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index/index'
import Login from '@/pages/login/login'
import Course from '@/pages/course/course'
import Works from '@/pages/works/works'
import User from '@/pages/user/user'
import About from '@/pages/about/about'
import School from '@/pages/school/school'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/course',
      name: 'Course',
      component: Course
    },
    {
      path: '/works',
      name: 'Works',
      component: Works
    },
    {
      path: '/user',
      name: 'User',
      component: User
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/school',
      name: 'School',
      component: School
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js